import {Animation} from 'animation';
import { addLabel, createButton } from 'src/library/minigame_client/ui/common/ui'
import UiSceneList from './uiscene_list';
import { lang } from './library/lang';
import {UiMenu} from "./library/minigame_client/ui/menu";
import {UiPanel} from "./library/minigame_client/ui/panel";

import SETTINGS from 'settings'


export default class UiScene extends PIXI.Container
{
    constructor(configGame, configMenu, configPanel) {

        super();

        let self = this;

        this.onClearBet = () => {};

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.packFolder;
        this.isDesktopHorizontal = configGame.type === "DesktopHorizontal";

        const config = configGame.UiScene;
        this.config = config;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");
        this.sndOrelClick = sounds.get("res/sounds/orel_click");
        this.sndReshkaClick = sounds.get("res/sounds/reshka_click");
        const snd = this.sndBtnClick;

        this.buttonSelectOrel   = createButton(this, config.buttonSelectOrel.pos.x, config.buttonSelectOrel.pos.y, packFolder + "orel", this.sndOrelClick, true);
        this.buttonSelectReshka = createButton(this, config.buttonSelectReshka.pos.x, config.buttonSelectReshka.pos.y, packFolder + "reshka", this.sndReshkaClick, true);

        //this.buttonGameMode     = createButton(this, config.buttonGameMode.pos.x, config.buttonGameMode.pos.x, packFolder + "s_mode", snd, true);
        this.buttonMore         = createButton(this, config.buttonMore.pos.x, config.buttonMore.pos.y, packFolder + "more", snd, true);
        this.buttonStop         = createButton(this, config.buttonStop.pos.x, config.buttonStop.pos.y, packFolder + "stop", snd, true);
        this.buttonMore.visible = false;
        this.buttonStop.visible = false;

        // create sprite 327x207 without texture
        // this.frameTotalBet = new PIXI.Sprite(new PIXI.Texture(PIXI.Texture.EMPTY, new PIXI.Rectangle(0, 0, 327, 207)));
        this.frameTotalBet = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "frame_total_bet.png"]);
        this.frameTotalBet.position.set(config.frameTotalBet.pos.x, config.frameTotalBet.pos.y);
        this.frameTotalBet.visible = false;
        this.addChild(this.frameTotalBet);
        this.labelTotalBet = addLabel(this.frameTotalBet,
            config.frameTotalBet.labelTotalBet.pos.x, config.frameTotalBet.labelTotalBet.pos.y,
            config.frameTotalBet.labelTotalBet.font.name, "center", 0.5, 0.5, config.frameTotalBet.labelTotalBet.font.tint);
        this.labelTotalBet.betValue = 0;
        addLabel(this.frameTotalBet,
            config.frameTotalBet.labelTotalBetBefore.pos.x, config.frameTotalBet.labelTotalBetBefore.pos.y,
            config.frameTotalBet.labelTotalBetBefore.font.name);
        addLabel(this.frameTotalBet,
            config.frameTotalBet.labelTotalBetAfter.pos.x, config.frameTotalBet.labelTotalBetAfter.pos.y,
            config.frameTotalBet.labelTotalBetAfter.font.name);
        this.frameTotalBet.chooseOrel = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "choose_orel.png"]);
        this.frameTotalBet.chooseOrel.position.set(config.frameTotalBet.chooseOrel.pos.x, config.frameTotalBet.chooseOrel.pos.y);
        this.frameTotalBet.addChild(this.frameTotalBet.chooseOrel);
        this.frameTotalBet.chooseReshka = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "choose_reshka.png"]);
        this.frameTotalBet.chooseReshka.position.set(config.frameTotalBet.chooseReshka.pos.x, config.frameTotalBet.chooseReshka.pos.y);
        this.frameTotalBet.addChild(this.frameTotalBet.chooseReshka);
        this.frameTotalBet.chooseOrel.visible = this.frameTotalBet.chooseReshka.visible = false;
        this.currency = "RUB";

        this.labelResult = addLabel(this, config.labelResult.pos.x, config.labelResult.pos.y, config.labelResult.font.name);

        this.listResults = new UiSceneList(configGame);
        this.addChild(this.listResults);

        this.imgSelectLightOrel = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "orel/down.png"]);
        this.imgSelectLightOrel.position.set(config.imgSelectLightOrel.pos.x, config.imgSelectLightOrel.pos.y);
        this.addChild(this.imgSelectLightOrel);

        this.imgSelectLightReshka = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "reshka/down.png"]);
        this.imgSelectLightReshka.position.set(config.imgSelectLightReshka.pos.x, config.imgSelectLightReshka.pos.y);
        this.addChild(this.imgSelectLightReshka);

        this.animSelectLight = Animation.byFrameName(packFolder + "select_light_%d.png", 17);
        this.animSelectLight.animationSpeed = 0.2;
        this.animSelectLight.loop = true;
        this.addChild(this.animSelectLight);

        this.imgSelectLightOrel.visible = this.imgSelectLightReshka.visible = this.animSelectLight.visible = false;

        this.labelCoeff = addLabel(this, config.labelCoeff.pos.x, config.labelCoeff.pos.y, config.labelCoeff.font.name);

        if (!this.isDesktopHorizontal) {
            // this.layerSwipeInput = new PIXI.Sprite(PIXI.Texture.WHITE);
            this.layerSwipeInput = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this.layerSwipeInput.width = 160;
            this.layerSwipeInput.height = 160;
            this.layerSwipeInput.anchor.set(0.0, 0.0);
            this.layerSwipeInput.position.set(configGame.MainScene.coin.pos.x + 48, configGame.MainScene.coin.pos.y + 314);
            this.layerSwipeInput.interactive = true;     // block interactive of overlaid buttons
            this.layerSwipeInput.visible = true;
            this.addChild(this.layerSwipeInput);

            this.hand = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "only_this_mode/hand.png"]);
            const upPosY = configGame.MainScene.coin.pos.y  + 445;
            this.hand.position.set(configGame.MainScene.coin.pos.x + 101, upPosY);
            this.addChild(this.hand);

            this.headTween = new TWEEN.Tween(this.hand.position)
                .to({y: upPosY - 15}, 1500)
                .repeat(Infinity)
                .delay(50)
                .yoyo(true)
                .easing(TWEEN.Easing.Cubic.InOut)
                .start();
        }

        this.uiMenu = new UiMenu(configMenu);
        this.addChild(this.uiMenu);

        this.uiPanel = new UiPanel(configPanel);
        this.addChild(this.uiPanel);

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container && !this.isDesktopHorizontal) {
            this.removeChild(this.uiMenu);
            this.removeChild(this.uiPanel);

            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.uiMenu);
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.addChild(this.uiPanel);
        }

        this.uiPanel.setOnTotalBetChanged(this.setLabelTotalBet.bind(this));
        this.uiPanel.setOnDigitPanelMove(function (isUp) {
            if (isUp) {
                self.uiMenu.sendAutoplayOffEvent();
                self.setAutoPlayButtonState(false);
                self.uiMenu.setAlphaAllButtons(0.5);
            }
            else {
                self.uiMenu.setAlphaAllButtons(1.0);
            }
        });

        if (!this.isDesktopHorizontal) {
            this.layerSwipeInput.on('pointerdown', function () {
                self.uiPanel.sendPlaceBetEvent();
            });
        }

        this.curState = null;
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        if (SETTINGS.ROOT_CONTAINERS.ui_adaptive_container)
            SETTINGS.ROOT_CONTAINERS.ui_adaptive_container.removeChildren();

        this.buttonSelectOrel = null;
        this.buttonSelectReshka = null;
        //this.buttonGameMode = null;
        this.buttonMore = null;
        this.buttonStop = null;

        this.frameTotalBet.chooseOrel = null;
        this.frameTotalBet.chooseReshka = null;
        this.frameTotalBet = null;
        this.imgSelectLightOrel = null;
        this.imgSelectLightReshka = null;

        this.labelResult = null;
        this.labelCoeff = null;

        this.animSelectLight.destroy();
        this.animSelectLight = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
        this.sndOrelClick.stop();
        this.sndOrelClick = null;
        this.sndReshkaClick.stop();
        this.sndReshkaClick = null;

        this.listResults.terminate();
        this.listResults = null;

        this.uiMenu.terminate();
        this.uiMenu = null;

        this.uiPanel.terminate();
        this.uiPanel = null;

        if (!this.isDesktopHorizontal) {
            this.layerSwipeInput = null;
            this.hand = null;
            this.headTween = null;
        }
    }

    addLobbyButtonToNewParrent (newParent) {
        this.uiMenu.addLobbyButtonToNewParrent(newParent);
    }

    resetLobbyButtonParrent () {
        this.uiMenu.addLobbyButtonToNewParrent(this.uiMenu);
    }

    getTotalBet () {
        return this.uiPanel.getTotalBet();
    }

    panelUp () {
        this.uiPanel.panelUp();
    }

    panelDown () {
        this.uiPanel.panelDown();
    }

    setState(state, isX2Mode = false) {
        let self = this;

        this.curState = state;

        // lock all and then unlock only needed in current mode
        //this.buttonGameMode.enabled = false;

        this.uiMenu.lockSettingsButton();

        this.buttonSelectOrel.enabled = false;
        this.buttonSelectReshka.enabled = false;
        this.buttonMore.enabled = false;
        this.buttonStop.enabled = false;

        this.buttonMore.visible = false;
        this.buttonStop.visible = false;

        if (!this.isDesktopHorizontal) {
            this.hand.visible = false;
        }

        switch(state) {

            case "INIT": {
                this._tryUnlockPlaceBet();

                //this.buttonGameMode.enabled = true;
                this.uiMenu.unlockSettingsButton();
            }
                break;

            case "ROTATE": {
                this.labelResult.text = "";
                if (isX2Mode) {
                    this.buttonMore.visible = this.buttonStop.visible = true;
                }
            }
                break;

            case "STOP": {
                if (isX2Mode) {
                    this.buttonMore.visible = this.buttonStop.visible = true;
                }
            }
                break;
            case "UNLOCK_X2MODE": {
                this.buttonMore.visible = this.buttonStop.visible = true;
                this.buttonMore.enabled = this.buttonStop.enabled = true;
            }
                break;
            default: break;
        }
    }

    setCoefficient (coefficient) {
        this.labelCoeff.text = "x " + coefficient;
    }

    setCurrency (currency) {
        this.uiPanel.setCurrency(currency);
    }

    setLabelTotalBet (totalBetStr, currencyStr) {
        this.frameTotalBet.visible = this.config.frameTotalBet.visible;

        let labels = this.frameTotalBet.children;

        const translateList = {
            bet: {
                rus: 'Ваша ставка:   ',
                eng: '   Your bet:   '
            }
        };

        // строка с разными шрифтами
        labels[0].text = totalBetStr;
        labels[1].text = translateList.bet[lang()];
        labels[2].text = ' ' + currencyStr;

        let width = 0;
        for (let i = 0; i < 3; ++i) {
            labels[i].align = "left";
            labels[i].anchor.set(0.0, 0.0);
            width += labels[i].getLocalBounds().width;
        }

        if (this.isDesktopHorizontal) {
            let y = 95;
            let x = (this.frameTotalBet.getLocalBounds().width - width) / 2.0;
            labels[1].position.set(x, y + 5);

            x += labels[1].getLocalBounds().width;
            labels[0].position.set(x, y);

            x += labels[0].getLocalBounds().width;
            labels[2].position.set(x, y + 1);
        }
        else {
            width -= labels[1].getLocalBounds().width;

            let y = 60;
            labels[1].position.set(40, y);

            let x = (this.frameTotalBet.getLocalBounds().width - width) / 2.0;


            labels[0].position.set(x, y + 20);

            x += labels[0].getLocalBounds().width;
            labels[2].position.set(x, y + 21);
        }

        if (!this.isDesktopHorizontal) {
            if (totalBetStr === ' ' || totalBetStr === '0') {
                this.hand.visible = false;
                this.onClearBet(true);
            }
            else {
                this.hand.visible = !this.uiPanel.isLockPlaceBetButton();
                this.onClearBet(false);
            }
        }
    }

    setOnClearBetEvent (func) {
        this.onClearBet = func;
    }

    setResult (win, isOrel, precision, delimiter) {
        const translateList = {
            win: {
                rus: 'Повезло, играем дальше?',
                eng: 'Luck, keep playing?'
            },
            lose: {
                rus: 'Не повезло, играем еще?',
                eng: 'No luck, continue playing?'
            }
        };

        if (win > 0) {
            this.labelResult.text = translateList.win[lang()];
        }
        else {
            this.labelResult.text = translateList.lose[lang()];
        }

        this.listResults.addResult(win, isOrel, precision, delimiter, this.uiPanel.getTotalBetCurrency());
    }

    setHistory (history) {
        this.listResults.setHistory(history);
    }

    setLabelCredits (credits, precision, delimiter) {
        this.uiPanel.setLabelCredits(credits, precision, delimiter);
    }

    setOnButtonPlaceBetEvent (func) {
        this.uiPanel.setOnPlaceBet(func);
    }

    setOnButtonMoreEvent (func) {
        // this.buttonMore.callback = function() {func();};
    }

    setOnButtonStopEvent (func) {
        // this.buttonStop.callback = function() {func();};
    }

    setSelectedButtonVisualisation (isOrel) {
        this.imgSelectLightOrel.visible = isOrel;
        this.imgSelectLightReshka.visible = !isOrel;

        this.animSelectLight.position = isOrel ? this.config.animSelectLightOrel.pos : this.config.animSelectLightReshka.pos;
        this.animSelectLight.visible = true;
        this.animSelectLight.gotoAndPlay(0);

        this.frameTotalBet.visible = this.config.frameTotalBet.visible;
        this.frameTotalBet.chooseOrel.visible = isOrel;
        this.frameTotalBet.chooseReshka.visible = !isOrel;
    }

    setOnButtonSelectOrelEvent (func) {
        let self = this;
        this.buttonSelectOrel.callback = function() {
            self.setSelectedButtonVisualisation(true);
            // self._tryUnlockPlaceBet();
            func();};
    }

    setOnButtonSelectReshkaEvent (func) {
        let self = this;
        this.buttonSelectReshka.callback = function() {
            self.setSelectedButtonVisualisation(false);
            // self._tryUnlockPlaceBet();
            func();};
    }

    setOnButtonSettingsEvent (func) {
        this.uiMenu.setOnButtonSettingsEvent(func);
    }

    setOnButtonHelpEvent (func) {
        this.uiMenu.setOnButtonHelpEvent(func);
    }

    /*setOnButtonModeEvent (func) {
        this.buttonGameMode.callback = function() {func();};
    }*/

    setOnButtonExitEvent (func) {
        this.uiMenu.setOnButtonExitEvent(func);
    }

    // вкл - когда кнопка soundOff отжимается
    setOnButtonSoundOnEvent (func) {
        this.uiMenu.setOnButtonSoundOnEvent(func);
    }

    // выкл - когда кнопка soundOn отжимается
    setOnButtonSoundOffEvent (func) {
        this.uiMenu.setOnButtonSoundOffEvent(func);
    }

    setSoundButtonState (isOn) {
        this.uiMenu.setSoundButtonState(isOn);
    }

    // вкл - когда кнопка buttonAutoOff отжимается
    setOnButtonAutoPlayOnEvent (func) {
        this.uiMenu.setOnButtonAutoPlayOnEvent(func);
    }

    // выкл - когда кнопка buttonAutoOn отжимается
    setOnButtonAutoPlayOffEvent (func) {
        this.uiMenu.setOnButtonAutoPlayOffEvent(func);
    }

    isLockPlaceBetButton () {
        return this.uiPanel.isLockPlaceBetButton();
    }

    setAutoPlayButtonVisible (isVisible) {
        this.uiMenu.setAutoPlayButtonVisible(isVisible);
    }

    setAutoPlayButtonState (isOn) {
        this.uiMenu.setAutoPlayButtonState(isOn);
    }

    setAutoPlayButtonEnable (isEnable) {
        this.uiMenu.setAutoPlayButtonEnable(isEnable);
    }

    setModelBet (bet, isInitState) {
        this.uiPanel.setModelBet(bet, isInitState);
        if (isInitState)
            this._tryUnlockPlaceBet();
    }

    setModelChoiceCoinSide (isOrel) {
        isOrel ? this.buttonSelectOrel.callback() : this.buttonSelectReshka.callback();
    }

    setBetValues (arrBetsValue, precision, delimiter, minBet, maxBet, precisionCeil) {
        this.uiPanel.setBetValues(arrBetsValue, precision, delimiter, minBet, maxBet, precisionCeil);
    }

    _tryUnlockPlaceBet() {
        let isLockPlaceBetButton = !this.uiPanel.isLockPlaceBetButton();
        let isEnoughCredits = this.uiPanel.isEnoughCredits();

        this.buttonSelectOrel.enabled   = isLockPlaceBetButton;
        this.buttonSelectReshka.enabled = isLockPlaceBetButton;
        let labels = this.frameTotalBet.children;
        labels[0].visible = labels[1].visible = labels[2].visible = isEnoughCredits;

        if (!isEnoughCredits) {
            this.frameTotalBet.chooseOrel.visible = this.frameTotalBet.chooseReshka.visible = false;
            this.imgSelectLightOrel.visible = this.imgSelectLightReshka.visible = false;
            this.animSelectLight.visible = false;
        }

        this.setAutoPlayButtonEnable(isEnoughCredits);
        if (!isEnoughCredits) {
            this.uiMenu.sendAutoplayOffEvent();
            this.setAutoPlayButtonState(false);
        }

        if (!this.isDesktopHorizontal) {
            this.hand.visible = isLockPlaceBetButton;
        }
    }
}



// WEBPACK FOOTER //
// ./src/uiscene.es6